export default {"src":"/_next/static/media/pantera.1efdc56d.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};